<template>
	<div :class="getImageClass">
		<div v-if="!parallax || isTablet" class="bg-box__background">
			<transition name="fade">
			<picture :key="'bgbox/' + this.getSection()">
  			<source media="(min-width: 82em)" :srcset="getImgSource('full')">
  			<source media="(min-width: 64em)" :srcset="getImgSource('laptop')">
  			<source media="(min-width: 36em)" :srcset="getImgSource('tablet')">
  			<img :src="getImgSource('full')" :style="getImageStyle" :alt="alt">
			</picture>
			</transition>
		</div>
		<ParallaxContainer v-else class="bg-box__background">
      <ParallaxElement
          :factor="getParallaxFactor"
          class="App__example-element"
        >
			<transition name="fade">
			<picture :key="'bgbox/' + this.getSection()">
  			<source media="(min-width: 82em)" :srcset="getImgSource('full')">
  			<source media="(min-width: 64em)" :srcset="getImgSource('laptop')">
  			<source media="(min-width: 36em)" :srcset="getImgSource('tablet')">
  			<img :src="getImgSource('full')" :style="getImageStyle" :alt="alt">
			</picture>
			</transition>
			</ParallaxElement>
		</ParallaxContainer>		
		<div class="container">
			<div class="wrapper">
				<slot></slot>
			</div>
		</div>	
	</div>
</template>

<script>

	// import Parallax from "vue-parallaxy";
	import ParallaxContainer from '@/components/Parallax/ParallaxContainer.vue';
	import ParallaxElement from '@/components/Parallax/ParallaxElement.vue';

	export default {

		components: {
			ParallaxContainer,
			ParallaxElement
		},

		props: {
			invert: {
				type: Boolean,
				default: false
			},
			opacity: {
				type: Number,
				default: .07
			},
			src: {
				type: String,
				default: 'header'
			},
			parallax: {
				type: Boolean,
				default: false
			},
			alt: {
				type: String,
				default: ''
			}
		},

		computed: {

			getImageClass: function() {

				var c = 'bg-box';

				if ( this.invert) {

					c += ' white';

				}

				return c;

			},

			getImageStyle: function() {

				var c = '';

				if ( this.opacity !== .07 ) {
					c += 'opacity: ' + this.opacity;
				}

				return c;

			},

			getParallaxFactor: function() {

				var factor = -.75;

				if ( this.isLaptop ) {

					factor = -.45;

				}

				return factor;

			},

		},

		methods: {

			getImgSource: function(size) {

				var file = this.src;

				if ( size !== 'full' ) {
					file += '-' + size;
				}

				var src = '/img/photos/' + file + '.jpg';
				return src

			}

		}

	}

</script>

<style lang="scss">
	
	// Potential concept for Parallax trickery
	// https://vuetifyjs.com/en/components/parallax

	.bg-box {

		background: $black;
		color: $white;		
		position: relative;
		overflow: hidden;
		transition: background-color .5s ease;

		&.white {
			background: $white;
			color: $black;

			.intro p {
				
				color: $black;

			}

			p {

				button {
					color: $blue-dark;
					text-decoration-color: rgba($blue-dark, .5);
					appearance: none;
					background: none;
					border: none;
					padding: 0 .05em;
					text-decoration: underline;

					&:hover,
					&:active {
						cursor: pointer;
					}

					&:hover,
					&:focus,
					&:active {
				
						color: $blue;
						text-decoration-color: rgba($blue, .8);
				
					}
				}

				a {

					&:link,
					&:visited {

						color: $blue-dark;
						text-decoration-color: rgba($blue-dark, .5);

						
					}

					&:hover,
					&:focus,
					&:active {

						color: $blue;
						text-decoration-color: rgba($blue, .8);

					}

				}

			}			

		}

		.container { 
			position: relative;
			z-index: 1;
			display: flex;
			justify-content: center;
			align-items: center;
		}

		.wrapper {

			width: 100%;
			max-width: $wrapper;
			margin: 6rem 1.5rem;

		}

		p {

			a {

				&:link,
				&:visited {

					color: $blue-light;
					text-decoration-color: rgba($blue-light, .5);
					
				}

				&:hover,
				&:focus,
				&:active {

					color: $white;
					text-decoration-color: rgba($white, .8);

				}

			}

		}

		.bg-box__background {
			position: absolute;
			z-index: 0;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
				object-position: bottom center;
				font-family: 'object-fit: cover; object-position: bottom center;';
				opacity: .07;

				@include mq(xwide) {
					object-position: top center;
					font-family: 'object-fit: cover; object-position: top center;';
				}
			}

		}
	}

</style>